import { useMemo } from "react";
import { toast } from "sonner";
import { applyTemplate, tplSlug } from "@/lib/templates";
import { useMeta } from "@/lib/meta";
import { computeLayout } from "@/lib/layout";
import { StampSvg } from "@/components/StampSvg";

export function TemplatesPanel({ product, design, setDesign, setSelected, ink, fontsTick }) {
  const meta = useMeta();
  const list = meta?.templates || [];
  const items = useMemo(
    () => list.map((t) => { const d = applyTemplate(product, t, design); return { t, d, layout: computeLayout(product, d) }; }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [product, design.border, design.graphics, fontsTick, list]
  );
  const scale = Math.min(150 / product.width_mm, 80 / product.height_mm);
  const pick = (t, d) => {
    const prev = design;
    setSelected(null);
    setDesign(d);
    if (window.innerWidth < 1024) document.querySelector("[data-testid=stamp-canvas]")?.scrollIntoView({ behavior: "smooth", block: "center" });
    toast.success(`Modello "${t.name}" applicato: ora sostituisci i testi con i tuoi dati (logo e QR caricati restano)`, { action: { label: "Annulla", onClick: () => setDesign(prev) } });
  };
  return (
    <div className="space-y-3" data-testid="templates-panel">
      <h3 className="text-xl font-bold uppercase tracking-wide">Modelli pronti</h3>
      <p className="text-xs text-slate-500">Parti da un modello per la tua attività, poi modifica i testi nella scheda Testo.</p>
      {!list.length && <p className="text-sm text-slate-500" data-testid="templates-empty">Nessun modello disponibile.</p>}
      <div className="grid grid-cols-2 gap-2.5">
        {items.map(({ t, d, layout }) => (
          <button key={t.id} data-testid={`template-${tplSlug(t.name)}`} onClick={() => pick(t, d)}
            className="press group rounded-lg border border-slate-200 bg-white hover:border-brand-navy overflow-hidden text-left">
            <div className="ink-grid h-24 flex items-center justify-center pointer-events-none">
              <StampSvg layout={layout} color={ink} scale={scale} />
            </div>
            <div className="px-2.5 py-2 text-xs font-semibold group-hover:text-brand-navy">{t.name}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
